import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { AuthService } from '../shared/services/auth.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UsersService {

  constructor(
    private _http:Http,
    private _authService:AuthService
  ) { }

  getUsers() {
    const url = `${environment.apiUrl}users/all`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  saveUser(user) {
    const url = `${environment.apiUrl}users/add`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, user, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  editUser(user) {
    const url = `${environment.apiUrl}users/edit`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, user, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }
  //
  // addColor(mat, color) {
  //   const url = `${environment.apiUrl}colors/add`;
  //   const token = this._authService.getToken();
  //   const headers = new Headers({
  //     'Content-Type': 'application/json',
  //     'Authorization': 'Bearer '+token
  //   });
  //   const options = new RequestOptions({ headers: headers });
  //   return this._http.post(url, {material:mat, color:color}, options)
  //     .map( (resp: Response) => {
  //       return resp.json()
  //     })
  //     .catch( (error: any) =>  {
  //       return Observable.throw(error)
  //     })
  // }
  //
  delUser(user) {
    const url = `${environment.apiUrl}users/delete`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {id:user._id}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }
  //
  // delColor(mat, color) {
  //   const url = `${environment.apiUrl}colors/delete`;
  //   const token = this._authService.getToken();
  //   const headers = new Headers({
  //     'Content-Type': 'application/json',
  //     'Authorization': 'Bearer '+token
  //   });
  //   const options = new RequestOptions({ headers: headers });
  //   return this._http.post(url, {material:mat, color:color}, options)
  //     .map( (resp: Response) => {
  //       return resp.json()
  //     })
  //     .catch( (error: any) =>  {
  //       return Observable.throw(error)
  //     })
  // }

}



// WEBPACK FOOTER //
// ./src/app/users/users.service.ts